// import React, { Fragment } from "react";
// import PropTypes from "prop-types";
// import {
//   useTable,
//   useGlobalFilter,
//   useSortBy,
//   useFilters,
//   useExpanded,
//   usePagination,
// } from "react-table";
// import { Table, Row, Col, Button } from "react-bootstrap";
// import { DefaultColumnFilter } from "./Filter";

// import { ProductsGlobalFilter } from "./GlobalSearchFilter";

// interface GlobalFilterProps {
//   preGlobalFilteredRows?: any;
//   globalFilter?: any;
//   setGlobalFilter?: any;
//   SearchPlaceholder?: string;
//   isProductsFilter?: boolean;
// }

// // Define a default UI for filtering
// function GlobalFilter({
//   preGlobalFilteredRows,
//   globalFilter,
//   setGlobalFilter,
//   SearchPlaceholder,
//   isProductsFilter,
// }: GlobalFilterProps) {
//   const [value, setValue] = React.useState(globalFilter);
//   const onChange = (value: any) => {
//     setGlobalFilter(value || undefined);
//   };

//   return (
//     <React.Fragment>
//       {isProductsFilter && <ProductsGlobalFilter />}
//       <Col className="col-sm">
//         {/* <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block"> */}
//         <div className="d-flex justify-content-sm-end">
//           <label htmlFor="search-bar-0" className="search-label">
//             {/* <span id="search-bar-0-label" className="sr-only">
//                 Search this table
//               </span> */}
//             <input
//               onChange={(e) => {
//                 setValue(e.target.value);
//                 onChange(e.target.value);
//               }}
//               id="search-bar-0"
//               type="text"
//               className="form-control"
//               placeholder={SearchPlaceholder}
//               value={value || ""}
//             />
//           </label>
//           <i className="bx bx-search-alt search-icon"></i>
//         </div>
//         {/* </div> */}
//       </Col>
//     </React.Fragment>
//   );
// }

// interface TableContainerProps {
//   columns?: any;
//   data?: any;
//   isGlobalFilter?: any;
//   isAddOptions?: any;
//   divClassName?: any;
//   theadClassName?: any;
//   tableClass?: any;
//   theadClass?: any;
//   isBordered?: boolean;
//   isAddUserList?: any;
//   handleOrderClicks?: any;
//   handleUserClick?: any;
//   handleCustomerClick?: any;
//   isAddCustList?: any;
//   customPageSize?: any;
//   className?: any;
//   customPageSizeOptions?: any;
//   iscustomPageSize?: boolean;
//   SearchPlaceholder: string;
//   isProductsFilter?: boolean;
//   manualPagination?: boolean;
//   pageCount?: number;
//   currentPage?: number;
//   onPageChange?: (page: number) => void;
//   onPageSizeChange?: (size: number) => void;
// }

// const TableContainer = ({
//   columns,
//   data,
//   tableClass,
//   theadClass,
//   isBordered,
//   isGlobalFilter,
//   isProductsFilter,
//   isAddOptions,
//   isAddUserList,
//   handleOrderClicks,
//   handleUserClick,
//   handleCustomerClick,
//   isAddCustList,
//   customPageSize,
//   iscustomPageSize,
//   customPageSizeOptions,

//   SearchPlaceholder,

//   // Add these props:
//   manualPagination,
//   pageCount,
//   currentPage,
//   onPageChange,
//   onPageSizeChange,
// }: TableContainerProps) => {
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     prepareRow,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     state,
//     preGlobalFilteredRows,
//     setGlobalFilter,
//     state: { pageIndex, pageSize },
//   } = useTable(
//     {
//       columns,
//       data,
//       manualPagination: manualPagination || false, // enable manual pagination mode
//       pageCount: pageCount,
//       initialState: {
//         pageIndex: currentPage || 0,
//         pageSize: customPageSize,
//       },
//     },
//     useGlobalFilter,
//     useFilters,
//     useSortBy,
//     useExpanded,
//     usePagination
//   );

//   const generateSortingIndicator = (column: any) => {
//     return column.isSorted ? (
//       column.isSortedDesc ? (
//         <span>&#9650;</span>
//       ) : (
//         <span>&#9660;</span>
//       )
//     ) : (
//       ""
//     );
//   };

//   const onChangeInSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
//     const size = Number(event.target.value);
//     if (onPageSizeChange) onPageSizeChange(size);
//   };

//   const onPageClick = (page: number) => {
//     if (onPageChange) onPageChange(page);
//   };

//   return (
//     <Fragment>
//       {iscustomPageSize && (
//         <Col md={customPageSizeOptions ? 2 : 1}>
//           <select
//             className="form-select"
//             value={pageSize}
//             onChange={onChangeInSelect}
//           >
//             {[10, 20, 30, 40, 50].map((pageSize) => (
//               <option key={pageSize} value={pageSize}>
//                 Show {pageSize}
//               </option>
//             ))}
//           </select>
//         </Col>
//       )}
//       {isGlobalFilter && (
//         <GlobalFilter
//           preGlobalFilteredRows={preGlobalFilteredRows}
//           globalFilter={state.globalFilter}
//           setGlobalFilter={setGlobalFilter}
//           SearchPlaceholder={SearchPlaceholder}
//           isProductsFilter={isProductsFilter}
//         />
//       )}
//       {isAddOptions && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="success"
//               className="btn-rounded mb-2 me-2"
//               onClick={handleOrderClicks}
//             >
//               <i className="mdi mdi-plus me-1" />
//               Add New Order
//             </Button>
//           </div>
//         </Col>
//       )}
//       {isAddUserList && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="primary"
//               className="btn mb-2 me-2"
//               onClick={handleUserClick}
//             >
//               <i className="mdi mdi-plus-circle-outline me-1" />
//               Create New User
//             </Button>
//           </div>
//         </Col>
//       )}
//       {isAddCustList && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="success"
//               className="btn-rounded mb-2 me-2"
//               onClick={handleCustomerClick}
//             >
//               <i className="mdi mdi-plus me-1" />
//               Customers
//             </Button>
//           </div>
//         </Col>
//       )}

//       <div className="table-responsive react-table">
//         <Table
//           hover
//           {...getTableProps()}
//           className={tableClass}
//           bordered={isBordered}
//         >
//           <thead className={theadClass}>
//             {headerGroups.map((headerGroup: any) => (
//               <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((columns: any) => (
//                   <th key={columns.id}>
//                     <div className="" {...columns.getSortByToggleProps()}>
//                       {columns.render("Header")}
//                       {generateSortingIndicator(columns)}
//                     </div>
//                     {/* <Filter column={columns} /> */}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody {...getTableBodyProps()}>
//             {page.map((row: any) => {
//               prepareRow(row);
//               return (
//                 <Fragment key={row.getRowProps().key}>
//                   <tr>
//                     {row.cells.map((cell: any) => {
//                       return (
//                         <td key={cell.id} {...cell.getCellProps()}>
//                           {cell.render("Cell")}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 </Fragment>
//               );
//             })}
//           </tbody>
//         </Table>
//       </div>
//       <Row className="align-items-center mt-2 py-2 px-2 gy-2 text-center text-sm-start">
//         <div className="col-sm">
//           <div className="text-muted">
//             Showing <span className="fw-semibold">{pageIndex + 1}</span> of{" "}
//             <span className="fw-semibold">{pageCount}</span> Pages
//           </div>
//         </div>
//         <div className="col-sm-auto">
//           <ul className="pagination pagination-separated mb-0 justify-content-center justify-content-sm-start">
//             <li
//               className={!canPreviousPage ? "page-item disabled" : "page-item"}
//               onClick={() => onPageClick && onPageClick((currentPage ?? 0) - 1)}
//             >
//               <Button variant="link" className="page-link">
//                 Previous
//               </Button>
//             </li>

//             {Array.from({ length: pageCount || 0 }, (_, i) => (
//               <li
//                 key={i}
//                 className={currentPage === i ? "page-item active" : "page-item"}
//                 onClick={() => onPageClick && onPageClick(i)}
//               >
//                 <Button variant="link" className="page-link">
//                   {i + 1}
//                 </Button>
//               </li>
//             ))}

//             <li
//               className={!canNextPage ? "page-item disabled" : "page-item"}
//               onClick={() => onPageClick && onPageClick((currentPage ?? 0) + 1)}
//             >
//               <Button variant="link" className="page-link">
//                 Next
//               </Button>
//             </li>
//           </ul>
//         </div>
//       </Row>
//     </Fragment>
//   );
// };

// TableContainer.propTypes = {
//   preGlobalFilteredRows: PropTypes.any,
// };

// export default TableContainer;

import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button } from "react-bootstrap";
import { DefaultColumnFilter } from "./Filter";
import { ProductsGlobalFilter } from "./GlobalSearchFilter";

interface GlobalFilterProps {
  preGlobalFilteredRows?: any;
  globalFilter?: any;
  setGlobalFilter?: any;
  SearchPlaceholder?: string;
  isProductsFilter?: boolean;
}

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  SearchPlaceholder,
  isProductsFilter,
}: GlobalFilterProps) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = (value: any) => {
    setGlobalFilter(value || undefined);
  };

  return (
    <React.Fragment>
      {isProductsFilter && <ProductsGlobalFilter />}
      <Col className="col-sm">
        <div className="d-flex justify-content-sm-end">
          <label htmlFor="search-bar-0" className="search-label">
            <input
              onChange={(e) => {
                setValue(e.target.value);
                onChange(e.target.value);
              }}
              id="search-bar-0"
              type="text"
              className="form-control"
              placeholder={SearchPlaceholder}
              value={value || ""}
            />
          </label>
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </Col>
    </React.Fragment>
  );
}

interface TableContainerProps {
  columns?: any;
  data?: any;
  isGlobalFilter?: any;
  isAddOptions?: any;
  divClassName?: any;
  theadClassName?: any;
  tableClass?: any;
  theadClass?: any;
  isBordered?: boolean;
  isAddUserList?: any;
  handleOrderClicks?: any;
  handleUserClick?: any;
  handleCustomerClick?: any;
  isAddCustList?: any;
  customPageSize?: number;
  className?: any;
  customPageSizeOptions?: any;
  iscustomPageSize?: boolean;
  SearchPlaceholder?: string;
  isProductsFilter?: boolean;
  manualPagination?: boolean;
  pageCount?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  isFilterable?: boolean;
}

const TableContainer = ({
  columns,
  data = [],
  tableClass,
  theadClass,
  isBordered,
  isGlobalFilter,
  isProductsFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  iscustomPageSize,
  customPageSizeOptions,
  SearchPlaceholder,
  manualPagination = false,
  pageCount,
  currentPage,
  onPageChange,
  onPageSizeChange,
}: TableContainerProps) => {
  // sensible default
  const initialPageSize = customPageSize ?? 10;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page, // for pagination UI
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data,
      manualPagination: manualPagination || false,
      // only provide pageCount to react-table when manualPagination is true
      ...(manualPagination ? { pageCount } : {}),
      initialState: {
        pageIndex: currentPage ?? 0,
        pageSize: initialPageSize,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  // sync external customPageSize -> react-table's setPageSize
  useEffect(() => {
    if (typeof customPageSize === "number" && setPageSize) {
      setPageSize(customPageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customPageSize]);

  // Effective page index/count when using server/manual pagination
  const effectivePageIndex = manualPagination ? (currentPage ?? 0) : pageIndex;
  const effectivePageCount = manualPagination ? (pageCount ?? 0) : pageOptions.length;
  const effectiveCanPreviousPage = manualPagination ? effectivePageIndex > 0 : canPreviousPage;
  const effectiveCanNextPage = manualPagination ? effectivePageIndex < effectivePageCount - 1 : canNextPage;

  // Page size change handler: update react-table AND notify parent
  const onChangeInSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const size = Number(event.target.value);
    if (setPageSize) setPageSize(size);
    if (onPageSizeChange) onPageSizeChange(size);
  };

  const handlePreviousPage = () => {
    if (manualPagination && onPageChange) {
      const newPage = Math.max(0, effectivePageIndex - 1);
      if (newPage !== effectivePageIndex) onPageChange(newPage);
    } else if (canPreviousPage) {
      previousPage();
    }
  };

  const handleNextPage = () => {
    if (manualPagination && onPageChange) {
      const newPage = Math.min(Math.max(0, effectivePageCount - 1), effectivePageIndex + 1);
      if (newPage !== effectivePageIndex) onPageChange(newPage);
    } else if (canNextPage) {
      nextPage();
    }
  };

  const handlePageClick = (pageNumber: number) => {
    if (manualPagination && onPageChange) {
      if (pageNumber >= 0 && pageNumber < (pageCount ?? 1)) {
        onPageChange(pageNumber);
      }
    } else {
      gotoPage(pageNumber);
    }
  };

  // Sorting indicator
  const generateSortingIndicator = (column: any) => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        <span>&#9650;</span>
      ) : (
        <span>&#9660;</span>
      )
    ) : (
      ""
    );
  };

  return (
    <Fragment>
      {isGlobalFilter && (
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          SearchPlaceholder={SearchPlaceholder}
          isProductsFilter={isProductsFilter}
        />
      )}

      {isAddOptions && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="success"
              className="btn-rounded mb-2 me-2"
              onClick={handleOrderClicks}
            >
              <i className="mdi mdi-plus me-1" />
              Add New Order
            </Button>
          </div>
        </Col>
      )}

      {isAddUserList && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="primary"
              className="btn mb-2 me-2"
              onClick={handleUserClick}
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              Create New User
            </Button>
          </div>
        </Col>
      )}

      {isAddCustList && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="success"
              className="btn-rounded mb-2 me-2"
              onClick={handleCustomerClick}
            >
              <i className="mdi mdi-plus me-1" />
              Customers
            </Button>
          </div>
        </Col>
      )}

      <div className="table-responsive react-table">
        <Table
          hover
          {...getTableProps()}
          className={tableClass}
          bordered={isBordered}
        >
          <thead className={theadClass}>
            {headerGroups.map((headerGroup: any) => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <th key={column.id}>
                    <div {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row: any) => {
              prepareRow(row);
              return (
                <tr key={row.id} {...row.getRowProps()}>
                  {row.cells.map((cell: any) => (
                    <td key={cell.column.id} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="align-items-center mt-2 py-2 px-2 gy-2 text-center text-sm-start">
        <div className="col-sm">
          <div className="text-muted">
            Showing{" "}
            <span className="fw-semibold">
              {effectivePageIndex * pageSize + 1} to{" "}
              {Math.min((effectivePageIndex + 1) * pageSize, data.length)}
            </span>{" "}
            of <span className="fw-semibold">{data.length}</span> entries
          </div>
        </div>

        <div className="col-sm-auto">
          <ul className="pagination pagination-separated mb-0 justify-content-center justify-content-sm-start">
            <li
              className={!effectiveCanPreviousPage ? "page-item disabled" : "page-item"}
              onClick={handlePreviousPage}
              style={{
                cursor: effectiveCanPreviousPage ? "pointer" : "default",
              }}
            >
              <Button
                variant="link"
                className="page-link"
                disabled={!effectiveCanPreviousPage}
              >
                Previous
              </Button>
            </li>

            {(() => {
              const pages = [];
              const pageNeighbours = 2;
              const totalPages = effectivePageCount;
              const currentPageIdx = effectivePageIndex;

              // Always show first page
              if (totalPages > 0 && currentPageIdx > pageNeighbours + 1) {
                pages.push(
                  <li
                    key={0}
                    className={currentPageIdx === 0 ? "page-item active" : "page-item"}
                    onClick={() => handlePageClick(0)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      1
                    </Button>
                  </li>
                );
                if (currentPageIdx > pageNeighbours + 2) {
                  pages.push(
                    <li key="ellipsis-start" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
              }

              const startPage = Math.max(0, currentPageIdx - pageNeighbours);
              const endPage = Math.min(totalPages - 1, currentPageIdx + pageNeighbours);

              for (let i = startPage; i <= endPage; i++) {
                pages.push(
                  <li
                    key={i}
                    className={currentPageIdx === i ? "page-item active" : "page-item"}
                    onClick={() => handlePageClick(i)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      {i + 1}
                    </Button>
                  </li>
                );
              }

              // Always show last page
              if (totalPages > 0 && currentPageIdx < totalPages - pageNeighbours - 1) {
                if (currentPageIdx < totalPages - pageNeighbours - 2) {
                  pages.push(
                    <li key="ellipsis-end" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
                pages.push(
                  <li
                    key={totalPages - 1}
                    className={currentPageIdx === totalPages - 1 ? "page-item active" : "page-item"}
                    onClick={() => handlePageClick(totalPages - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      {totalPages}
                    </Button>
                  </li>
                );
              }

              return pages;
            })()}

            <li
              className={!effectiveCanNextPage ? "page-item disabled" : "page-item"}
              onClick={handleNextPage}
              style={{ cursor: effectiveCanNextPage ? "pointer" : "default" }}
            >
              <Button
                variant="link"
                className="page-link"
                disabled={!effectiveCanNextPage}
              >
                Next
              </Button>
            </li>
          </ul>
        </div>
      </Row>
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
